module.exports = __webpack_public_path__ + "img/reunionSanJuan.1932d2d4.jpg";